import React, { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import Get from '../../api/internal/Get';
import BBITable from '../../helpers/bBITable/BBITable';
import DateOnlyUTCFormatter from '../../helpers/inputs/DateOnlyUTCFormatter';
import DateTimeUTCFormatter from '../../helpers/inputs/DateTimeUTCFormatter';
import Button from '../../assets/essentials/Button';
import Create from '../../helpers/modal/CreateModal';
import Modal from '../../helpers/modal/Modal';
import EditEvent from './EditEvent';
import EventActionModal from './EventActionModal';
import FilterData from '../../helpers/filter/FilterData';
import Header from '../../layouts/Header';
import { MdOutlineRefresh } from 'react-icons/md';

type OutletContext = {
  filterValue: string;
};

const ManageEvents = () => {
  const [pendingEvents, setPendingEvents] = useState<PendingDriverEvent[]>([]);
  const { filterValue } = useOutletContext<OutletContext>();

  useEffect(() => {
    GetPendingApprovalEvents();
  }, []);

  function GetPendingApprovalEvents() {
    Get('Schedule/GetPendingApprovalEvents').then(res => {
      if (res) {
        setPendingEvents(res.data);
      }
    });
  }

  function formatData(events: DriverEvent[]) {
    return events.map(event => ({
      ...event,
      startDate: DateOnlyUTCFormatter(event.startDate),
      endDate: event.endDate ? DateOnlyUTCFormatter(event.endDate) : '',
      requestedDate: event.requestedDate
        ? DateOnlyUTCFormatter(event.requestedDate)
        : '',
      approvedDate: event.approvedDate
        ? DateOnlyUTCFormatter(event.approvedDate)
        : '',
      createdDate: DateTimeUTCFormatter(event.createdDate),
      modifiedDate: event.modifiedDate
        ? DateTimeUTCFormatter(event.modifiedDate)
        : '',
      isAllDay: event.isAllDay ? '✅' : '❌',
      actions: (
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <Button onClick={() => handleEdit(event)}>Edit</Button>
          <Button variant="good" onClick={() => handleApprove(event)}>
            Approve
          </Button>
          <Button variant="bad" onClick={() => handleDeny(event)}>
            Deny
          </Button>
        </div>
      ),
    }));
  }

  const handleEdit = (event: DriverEvent) => {
    Create(
      <Modal>
        <EditEvent event={event} onSuccess={GetPendingApprovalEvents} />
      </Modal>,
    );
  };

  const handleApprove = (event: DriverEvent) => {
    Create(
      <Modal>
        <EventActionModal
          event={event}
          action="approve"
          onSuccess={GetPendingApprovalEvents}
        />
      </Modal>,
    );
  };

  const handleDeny = (event: DriverEvent) => {
    Create(
      <Modal>
        <EventActionModal
          event={event}
          action="deny"
          onSuccess={GetPendingApprovalEvents}
        />
      </Modal>,
    );
  };

  const columnConfig = [
    {
      key: '1',
      attribute: 'driverName',
      attributeprimaryhidden: 'driverId',
      header: 'Driver',
    },
    {
      key: '2',
      attribute: 'eventTypeName',
      attributeprimaryhidden: 'eventTypeId',
      header: 'Event Type',
    },
    {
      key: '3',
      attribute: 'eventStatusName',
      attributeprimaryhidden: 'eventStatusId',
      header: 'Status',
    },
    {
      key: '4',
      attribute: 'startDate',
      header: 'Start Date',
    },
    {
      key: '5',
      attribute: 'endDate',
      header: 'End Date',
    },
    {
      key: '6',
      attribute: 'isAllDay',
      header: 'All Day',
    },
    {
      key: '7',
      attribute: 'notes',
      header: 'Notes',
    },
    {
      key: '8',
      attribute: 'requestedDate',
      header: 'Requested Date',
    },
    {
      key: '9',
      attribute: 'createdByEmployeeName',
      attributeprimaryhidden: 'createdByEmployeeId',
      header: 'Created By',
    },
    {
      key: '10',
      attribute: 'createdDate',
      header: 'Created Date',
    },
    {
      key: '11',
      attribute: 'modifiedByEmployeeName',
      attributeprimaryhidden: 'modifiedByEmployeeId',
      header: 'Modified By',
    },
    {
      key: '12',
      attribute: 'modifiedDate',
      header: 'Modified Date',
    },
    {
      key: '13',
      attribute: 'actions',
      header: 'Actions',
    },
  ];

  return (
    <>
      <h1>Pending Events</h1>
      <BBITable
        data={FilterData(formatData(pendingEvents), filterValue)}
        columns={columnConfig}
      />
    </>
  );
};

export default ManageEvents;
